import { Injectable } from "@angular/core";
import { KeycloakService } from "keycloak-angular";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private keycloakInitialized = false;
    private profileSubject = new BehaviorSubject<any | null>(null);
    profile$ = this.profileSubject.asObservable();
    private isLoggedInSubject = new BehaviorSubject<boolean>(false);
    isLoggedIn$ = this.isLoggedInSubject.asObservable();

    constructor(private keycloakService: KeycloakService) { }

    async initialize(): Promise<void> {
        await this.keycloakService.init({
            config: {
                url: environment.KEYCLOAK_URL,
                realm: environment.KEYCLOAK_REALM,
                clientId: environment.KEYCLOAK_CLIENT_ID,
            },
            initOptions: {
                onLoad: 'login-required',
                checkLoginIframe: false,
                redirectUri: window.location.origin + '/interno',
            },
            bearerExcludedUrls: ['/assets'],
        });

        this.keycloakInitialized = true;
        await this.updateProfile();
    }

    async isLoggedIn(): Promise<boolean> {
        var l = await this.keycloakService.isLoggedIn()
        this.isLoggedInSubject.next(l);
        return l;
    }

    async login(redirectUri: string): Promise<void> {
        await this.keycloakService.login({ redirectUri: redirectUri });
        await this.updateProfile();
    }

    async logout(redirectUri: string): Promise<void> {
        await this.keycloakService.logout(redirectUri);
        this.profileSubject.next(null);
    }

    async updateProfile(): Promise<void> {
        if (this.keycloakInitialized && await this.keycloakService.isLoggedIn()) {
            const profile = await this.keycloakService.loadUserProfile();
            this.profileSubject.next(profile);
        } else {
            this.profileSubject.next(null);
        }
    }

    isKeycloakInitialized(): boolean {
        return this.keycloakInitialized;
    }
}